import type {
  ConversationId,
  ConversationThreadId,
} from "@redotech/effect-api-shared/ids/definitions";
import type {
  Message,
  MessageChannel,
} from "@redotech/effect-api-shared/models/shopper-ai/conversation/message";
import { memo } from "react";
import { ChatMessageBubble } from "./chat-message-bubble";
import { MetaCommentActions } from "./meta-comment-actions";

interface MetaCommentChatMessageBubbleProps {
  message: Message;
  channel: MessageChannel;
  threadId: ConversationThreadId;
  conversationId: ConversationId;
}

export const MetaCommentChatMessageBubble = memo(
  function MetaCommentChatMessageBubble({
    message,
    channel,
    threadId,
    conversationId,
  }: MetaCommentChatMessageBubbleProps) {
    const channelData =
      message.channelData &&
      (message.channelData._tag === "facebookComment" ||
        message.channelData._tag === "instagramComment")
        ? message.channelData
        : null;

    const isHidden = channelData?.state === "hidden";
    const isDeleted = channelData?.state === "deleted";
    const liked = (channelData?.attributes ?? []).includes("liked");

    return (
      <ChatMessageBubble
        actions={
          channelData ? (
            <MetaCommentActions
              channel={channel}
              commentId={message.externalMessageId}
              conversationId={conversationId}
              hidden={isHidden}
              liked={liked}
              messageId={message.id}
              threadId={threadId}
            />
          ) : undefined
        }
        commentState={isHidden ? "hidden" : isDeleted ? "deleted" : undefined}
        liked={liked}
        message={message}
      />
    );
  },
);
